
export default {
  methods: {
    offerDateCheck(offer, startDate) {
      // EDMT-5268 check if dates set and match rules
      if (!startDate) { return true; } // show if no date

      if (startDate && offer.from && offer.to && offer.deadline) {
        const from = new Date(offer.from);
        from.setHours(12, 0, 0);

        const to = new Date(offer.to);
        to.setHours(12, 0, 0);

        const today = new Date();
        // the empty date is dynamic and calculation wrong. So we use 10:00:00
        today.setHours(10, 0, 0);

        const searchStart = new Date(startDate);
        searchStart.setHours(12, 0, 0);
        if ((searchStart.getTime() > from.getTime()) && (searchStart.getTime() < to.getTime())) { // matched period
          const daysleft = parseInt((searchStart.getTime() - today.getTime()) / (24 * 3600 * 1000), 10);
          const deadlineCheck = (daysleft > parseInt(offer.deadline, 10));
          return deadlineCheck; // deadline ok
        }
        return false;
      }
      return true;
    }
    ,
  },
  watch: {
    textids: {
      immediate: true,
      deep: true,
      handler(offerObjects) {
        if (offerObjects.length) {
          this.cancelAble({ objectNumber: this.objectNumber, cancelable: true });
        } else {
          this.cancelAble({ objectNumber: this.objectNumber, cancelable: false });
        }
      },
    },
  },
};
